import { SortingState } from '@tanstack/react-table';

export function sortByMapper(
  sortBy: SortingState | undefined,
  columnIdMap?: Record<string, string>,
): string | undefined {
  if (!sortBy || sortBy.length === 0) return undefined;
  const item = sortBy[0];
  return `${columnIdMap?.[item.id] ?? item.id}.${item.desc ? 'desc' : 'asc'}`;
}
